/// <amd-module name="Build/Admin/Pool/Stores/MaintenanceStore" />
import { Store } from "VSS/Reflux/Store";

import { TaskAgentPoolMaintenanceDefinition } from "DistributedTask/Client/Contracts/TaskAgent";

import { TaskAgentPoolsData, TaskAgentPoolData, TimeZoneData } from "Build/Admin/Common/Client/Contracts/DistributedTask/DataProvider";
import { StoreStatus } from "Build/Admin/Common/Constants";

export interface IMaintenanceStoreState {
    maintenanceDefinitions: TaskAgentPoolMaintenanceDefinition[];
    validTimeZones: TimeZoneData[];
    status: StoreStatus;
}

export class MaintenanceStore extends Store {
    public state: IMaintenanceStoreState = {
        maintenanceDefinitions: [],
        validTimeZones: [],
        status: StoreStatus.None
    };

    constructor() {
        super("MaintenanceStoreChanged");
    }

    public getMaintenanceDefinition(definitionId: number): TaskAgentPoolMaintenanceDefinition | undefined {
        if (this.state.maintenanceDefinitions.length > 0) {
            const matchingAgents: TaskAgentPoolMaintenanceDefinition[] = this.state.maintenanceDefinitions.filter(def => def.id === definitionId);
            return matchingAgents[0];
        }

        return undefined;
    }

    public updateStatus = (status: StoreStatus): void => {
        this.state = {
            ...this.state,
            status
        };

        this.emitChanged();
    }

    public updateMaintenanceDefinitions = (maintenanceDefinitions: TaskAgentPoolMaintenanceDefinition[]): void => {
        this.state = {
            ...this.state,
            status: StoreStatus.Loaded,
            maintenanceDefinitions
        };

        this.emitChanged();
    }

    public updateValidTimeZones = (timeZones: TimeZoneData[]): void => {
        this.state = {
            ...this.state,
            validTimeZones: timeZones
        };

        this.emitChanged();
    }

    public addMaintenanceDefinition = (definition: TaskAgentPoolMaintenanceDefinition): void => {
        if (this.state.maintenanceDefinitions.length === 0) {
            // Collection is empty, so just add it
            this.state = {
                ...this.state,
                maintenanceDefinitions: [definition]
            }

            this.emitChanged();
        }
        else {
            // Do an update instead, to make sure we're not adding a duplicate
            this.updateMaintenanceDefinition(definition);
        }
    }

    public updateMaintenanceDefinition = (definition: TaskAgentPoolMaintenanceDefinition): void => {
        const nonMatchingDefinitions = this.state.maintenanceDefinitions.filter(def => def.id !== definition.id);
        nonMatchingDefinitions.unshift(definition);

        this.state = {
            ...this.state,
            maintenanceDefinitions: nonMatchingDefinitions
        };

        this.emitChanged();
    }
}